import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { AuthLayout } from './AuthLayout';
import { send } from '../components';
import { toast } from 'sonner';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await send('io0014', {
      email,
    }, setLoading);
    if (res.status === "error") {
      toast.error(res.message);
    } else {
      toast.success(res);
    }
  };

  return (
    <AuthLayout title={t('resetPassword')} subtitle={t('welcomeBack')}>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="space-y-2">
          <Label htmlFor="email" className="text-sm font-medium">
            {t('email')}
          </Label>
          <div className="relative">
            <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              id="email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="pl-11"
              required
            />
          </div>
        </div>

        <Button
          type="submit"
          variant="gradient"
          size="lg"
          className="w-full"
          disabled={loading}
        >
          {loading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              {t('loading')}
            </>
          ) : (
            t('resetPassword')
          )}
        </Button>
        <div className="flex items-center justify-end">
          <Link
            to="/login"
            className="text-sm text-primary hover:text-primary/80 font-medium"
          >
            {t('login')}
          </Link>
        </div>
        <p className="text-center text-sm text-muted-foreground">
          {t('noAccount')}{' '}
          <Link to="/register" className="text-primary hover:text-primary/80 font-semibold">
            {t('signUp')}
          </Link>
        </p>
      </form>

      <p className="text-center text-xs text-muted-foreground mt-8">
        {t('termsAgree')}
      </p>
    </AuthLayout>
  );
};

export default ForgotPassword;
